export const Animations = {
  EaseOut: "transition ease-out duration-200",
  EaseIn: "transition ease-in duration-150",
  FadeOut: "opacity-0 translate-y-1",
  FadeIn: "opacity-100 translate-y-0",
};
